export enum ReminderTypeEnum {
    EMAIL = 'email',
    SMS = 'sms'
}